"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformConstructorAutocompleteResults = void 0;
const client_1 = require("../../../storeLocale/client");
const transformConstructorAutocompleteResults = (sections, shouldLowerCaseText) => {
    return ((sections === null || sections === void 0 ? void 0 : sections['Search Suggestions']) || []).map(({ value }) => {
        const text = shouldLowerCaseText ? value === null || value === void 0 ? void 0 : value.toLowerCase() : value;
        return {
            label: text,
            link: (0, client_1.addStoreLocaleByCookie)(`/all?query=${encodeURIComponent(text)}`),
        };
    });
};
exports.transformConstructorAutocompleteResults = transformConstructorAutocompleteResults;
